import {
  CustomerDataActionTypes,
  SET_CUSTOMER,
  Customers,
  SELECTED_CARD,
} from './types';

const initialState: Customers = {
  customers: [],
  selected: '',
};

export const paymentCustomerReducer = (
  state = initialState,
  action: CustomerDataActionTypes
): Customers => {
  const { type, customers } = action;
  switch (type) {
    case SELECTED_CARD:
      return { ...state, selected: action.selected };
    case SET_CUSTOMER:
      return { ...state, customers };

    default:
      return state;
  }
};
